import { lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WebsiteLayout from "../layouts/WebsiteLayout";
import ScrollToTop from "../components/common/ScrollToTop";

// Home is eager: it's the landing/LCP page, so we avoid an extra chunk round-trip.
import Home from "../pages/Home";

// Every other page is lazy so the initial bundle only carries the homepage.
// The <Suspense> boundary lives in WebsiteLayout (around <Outlet/>), so the
// Header/Footer shell stays painted while a page chunk loads.
const Phonics = lazy(() => import("../pages/Phonics"));
const CambridgeEnglish = lazy(() => import("../pages/CambridgeEnglish"));
const GrammarWriting = lazy(() => import("../pages/GrammarWriting"));
const SpokenEnglish = lazy(() => import("../pages/SpokenEnglish"));
const ViewAllCourse = lazy(() => import("../pages/ViewAllCourse"));
const ViewCourseDetails = lazy(() => import("../pages/ViewCourseDetails"));
const Centres = lazy(() => import("../pages/Centres"));
const CentresDetails = lazy(() => import("../pages/CentresDetails"));
const Certification = lazy(() => import("../pages/Certification"));
const Creative = lazy(() => import("../pages/Creative"));
const TrainingForSchools = lazy(() => import("../pages/TrainingForSchools"));
const DynamicPage = lazy(() => import("../pages/DynamicPage"));
const Contactus = lazy(() => import("../pages/Contactus"));
const ThankYou = lazy(() => import("../pages/ThankYou"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<WebsiteLayout />}>
          <Route index element={<Home />} />
          {/* Legacy hardcoded category routes — kept for backwards compatibility */}
          <Route path="Phonics" element={<Phonics />} />
          <Route path="CambridgeEnglish" element={<CambridgeEnglish />} />
          <Route path="GrammarWriting" element={<GrammarWriting />} />
          <Route path="SpokenEnglish" element={<SpokenEnglish />} />
          <Route path="ViewAllCourse" element={<ViewAllCourse />} />
          <Route path="ViewCourseDetails/:course_id" element={<ViewCourseDetails />} />
          <Route path="centres" element={<Centres />} />
          <Route path="CentresDetails/:centre_id" element={<CentresDetails />} />
          <Route path="centres/:centreSlug" element={<CentresDetails />} />
          <Route path="Certification" element={<Certification />} />
          <Route path="Creative" element={<Creative />} />
          <Route path="TrainingForSchools" element={<TrainingForSchools />} />
          <Route path="training-school" element={<TrainingForSchools />} />
          {/* Dynamic slug route — resolves admin Pages first, then course categories */}
          <Route path=":slug" element={<DynamicPage />} />
          <Route path=":categorySlug/:courseSlug" element={<ViewCourseDetails />} />
          <Route path="contact-us" element={<Contactus />} />
          <Route path=":categorySlug/:courseSlug/join-now" element={<Contactus />} />
          <Route path=":categorySlug/:courseSlug/enquiry" element={<Contactus />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="thank-you/schools-enquiry" element={<ThankYou />} />
          <Route path="thank-you/join-now" element={<ThankYou />} />
          <Route path="thank-you/contact" element={<ThankYou />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
